/* eslint-disable no-irregular-whitespace */
import { OverviewItems } from 'components/cases/common/Overview/Overview'
import { IssueSolutionItems } from 'components/cases/common/Overview/Overview'
import { CaseStudyItems } from 'components/cases/common/CaseStudy/CaseStudy'

// ファーストビュー
export const firstViewItem = {
  breadcrumb: 'PEACH JOHN 公式アプリ',
  title1: 'PEACH JOHN 公式アプリ',
  introduction_text:
    'アプリのリニューアルのご支援をさせていただきました。このプロジェクトは、コンセプトの再定義、ユーザーメリットと効果を鑑みた機能の取捨選択のワークショップなどを実施しました。弊社は、トーン＆マナーを考慮したUIデザイン、アプリ開発、継続的なシステム改修・運用を支援しています。',
  company: '株式会社ピーチ・ジョン',
  tag1text: 'アプリケーション開発',
  tag1src: '/cases/application-development/',
  tag2text: 'UX/UI改善',
  tag2src: '/cases/uxui-improvement/',
  tag3text: 'ZEBRA',
  tag3src: '/cases/zebra/',
  industryTagText: '小売/流通/卸',
  industryTagSrc: '/cases/retail/',
  color: '#222',
  background: 'linear-gradient(90deg, #FFE8E8 0%, #FFD9D9 100%)',
  staff1: '',
  staff2: '',
  image: '/images/img/cases/caseStudyTop/peachjohn.webp',
  alt: 'PEACH JOHN 公式アプリ',
  imgClass: 'fv_img_adjust2',
}

// プロジェクト概要
export const overviewTitle = 'コンセプト再定義などの上流から、システム改修・運用のご支援'
export const overviewItem: OverviewItems[] = [
  {
    text: 'アプリのリニューアルに伴い、コンセプトの再定義、ユーザーメリットと効果を鑑みた機能の取捨選択のワークショップ。既存のブランドから今回のリニューアルで刷新したいイメージとなるようなトーン＆マナーを考慮したUIデザイン、アプリ開発、継続的なシステム改修・運用をサポートしています。',
  },
]

// 課題と解決策
export const issueSolutionItems: IssueSolutionItems[] = [
  {
    issues: [
      {
        title: 'コンセプトの再定義とイメージの刷新',
        text: '',
      },
      {
        title: 'ユーザーメリットと効果を鑑みた機能の取捨選択',
        text: '',
      },
    ],
    solutions: [
      {
        title: 'コンセプトを表現するUIデザイン',
        text: '',
      },
      {
        title: 'ワークショップを実施して、機能の取捨選択',
        text: '',
      },
    ],
  },
]

// 関連事例
export const caseStudyItem: CaseStudyItems = [
  {
    projectName: '【技術系災害ボランティア体験】家屋再生〜水害編〜',
    client: '公益財団法人日本財団ボランティアセンター様',
    src: '/images/img/case/img_case_volunteer-ex.png',
    alt: '公益財団法人日本財団ボランティアセンター様',
    href: '#',
    tags: [{ name: 'XR/メタバース導入', url: 'xr' }],
  },
  {
    projectName: 'PEACH JOHN',
    client: '株式会社ピーチ・ジョン様',
    src: '/images/img/case/img_peachjohn.png',
    alt: '株式会社ピーチ・ジョン様',
    href: '#',
    tags: [
      { name: 'UX/UIデザイン', url: 'uiux' },
      { name: 'アプリケーション開発', url: 'application-development' },
      { name: '小売', url: 'service' },
    ],
  },
  {
    projectName: 'セブンネットショッピング「推し活倶楽部」',
    client: '株式会社セブンネットショッピング様',
    src: '/images/img/case/img_sevennet.png',
    alt: '株式会社セブンネットショッピング様',
    href: '#',
    tags: [
      { name: 'UX/UIデザイン', url: 'uiux' },
      { name: 'アーキテクチャ設計サービス', url: 'architecture-design' },
      { name: '小売', url: 'service' },
    ],
  },
]
